import React from 'react'
import HomeBanner from './home/HomeBanner'
import HomeAbout from './home/HomeAbout'
import HomeTestimonials from './home/HomeTestimonials'
import HomeBlog from './home/HomeBlog'
import WhyChoose from './home/WhyChoose'
import OurCertificate from './home/OurCertificate'
import HomeGallery from './home/HomeGallery'
import HomeServices from './home/HomeServices'
import HomeExpertTeam from './home/HomeExpertTeam'
import SuccessfulProjects from './home/SuccessfulProjects'
import WorkingProcess from './home/WorkingProcess'



const Home = () => {
  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <HomeBanner />
        <HomeAbout />
        <HomeServices />
        {/* <HomeExpertTeam /> */}
        <WhyChoose />
        <SuccessfulProjects />
        <WorkingProcess />
        <HomeGallery />
        {/* <OurCertificate /> */}
        <HomeTestimonials />
        <HomeBlog />
        
      </div>






    </>
  )
}

export default Home